export default function HookLoading() {
  return <div aria-label="loading" className="h-screen w-screen bg-app"></div>;
}
